<template>
  <div>
    <b-modal id="modal-upload-operation" size="lg" centered :title="$t('workspace.bulk-invite-result')" hide-footer>
      <div v-if="uploadResponse && uploadResponse.success.length > 0">
        <h5 class="text-success">{{ $t("common.success") }}</h5>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">{{ $t("common.name-surname2") }}</th>
              <th scope="col">Email</th>
              <th scope="col">{{ $t("role.text") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in uploadResponse.success" :key="item.id">
              <th style="width: 33%;">{{ item.name }}</th>
              <td style="width: 33%;">{{ item.email }}</td>
              <td style="width: 33%;">
                <div v-if="item.role">
                  <span v-for="role in item.role" :key="role._id">
                    <li>
                      {{ role | translate }}
                    </li>
                  </span>
                </div>
                <div v-else>
                  {{ $t("common.not-selected") }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="uploadResponse && uploadResponse.failed.length > 0">
        <h5 class="text-danger mt-4">{{ $t("common.failed") }}</h5>

        <table class="table">
          <thead>
            <tr>
              <th scope="col">{{ $t("common.name-surname2") }}</th>
              <th scope="col">Email</th>
              <th scope="col">{{ $t("role.text") }}</th>
              <th scope="col">{{ $t("alert.error") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in uploadResponse.failed" :key="item.id">
              <th>
                {{ item.name }}
              </th>
              <td>{{ item.email }}</td>
              <td>
                <span v-for="role in item.role" :key="role._id">
                  <li>
                    {{ role | translate }}
                  </li>
                </span>
              </td>
              <td style="width: 40%;">
                {{ item.cause }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <b-modal id="modal-role" size="sm" centered :title="$t('role.plural')" hide-footer>
      <div v-if="roles && roles.docs">
        <div v-for="item in roles.docs" :key="item.id">
          <ul>
            <li>
              {{ item.name | translate }}
            </li>
          </ul>
        </div>
      </div>
    </b-modal>

    <div class="alert alert-warning">
      <ul>
        <li>
          <p>{{ $t("workspace.invite-template.p1") }}</p>
        </li>
        <li>
          <p v-html="$t('workspace.invite-template.p5')"></p>
        </li>
        <li>
          <p>
            {{ $t("role.display") }}
            <a href="#" @click="openModal"> {{ $t("common.click") }}</a>
          </p>
        </li>
      </ul>
    </div>
    <div class="alert alert-info">{{ $t("workspace.invite-template.p6") }}</div>
    <div>
      <table class="table table-bordered">
        <tbody>
          <tr style="font-weight: bold;">
            <td>name</td>
            <td>email</td>
            <td>organizationRole</td>
            <td>language</td>
          </tr>
          <tr>
            <td>{{ $t("common.firstAndLastName") }}</td>
            <td>email@domain.com</td>
            <td>{{ $t("common.role") }} 1 , {{ $t("common.role") }} 2</td>
            <td>tr</td>
          </tr>
          <tr>
            <td>{{ $t("common.firstAndLastName") }}</td>
            <td>email@domain.com</td>
            <td>{{ $t("common.role") }} 3</td>
            <td>en</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="card bg-light">
      <div class="card-body">
        <file-rocket :allowedFormats="allowedFormats" @response="handleUploadResponse" :payload="editedOrganization" :maxFileSize="5242880" :targetUrl="targetUrl"></file-rocket>
      </div>
    </div>
  </div>
</template>

<script>
import { email, maxLength, minLength, required } from "vuelidate/lib/validators";
import FileRocket from "../../components/common/form/file-rocket.vue";

export default {
  props: { workspace: { type: Object }, store: { type: String, required: false } },
  components: { FileRocket },
  data() {
    return {
      uploadResponse: undefined,
      allowedFormats: ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
      form: {
        name: undefined,
        email: undefined,
        language: undefined,
      },
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(40),
      },
      workspaceRole: {
        required,
      },
      email: {
        email,
        required,
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters["workspace/isUpdating"];
    },
    languages() {
      return this.$store.getters["localization/languages"];
    },
    roles() {
      return this.$store.getters[`role/pagination`];
    },
    currentStore() {
      return this.store ? this.store : "organization";
    },
    targetUrl() {
      return `/${this.currentStore == "managementOrganization" ? "management/organization" : "organization"}/bulk-invite`;
    },
    editedOrganization() {
      return this.$store.getters[`${this.currentStore}/editedOrganization`];
    },
  },
  async mounted() {
    this.form.language = this.languages.find((l) => l.language == "tr");
    await this.paginateRoles();
  },
  methods: {
    async paginateRoles() {
      await this.$store.dispatch(`role/paginate`, {
        options: { limit: 200 },
        query: {},
      });
    },
    handleUploadResponse(event) {
      try {
        this.$emit("onSent");
        this.uploadResponse = event.data;
        this.$root.$emit("bv::show::modal", "modal-upload-operation");
      } catch (error) {
        this.handleUploadResponse(error, { customName: this.$t("organization.error") });
      }
    },
    onSelect() {
      this.$forceUpdate();
    },
    openModal() {
      this.$bvModal.show("modal-role");
    },
  },
};
</script>
